module.exports = __webpack_public_path__ + "static/media/room-9.462838ef.jpeg";